import React from 'react';
import { Accordion } from '@ver-uds/uswds-react';
import { State } from 'eve-account-client';
import { Tag } from '@ver-uds/react';

export type GroupAccordionHeaderProps = {
  hiringSiteState: State;
  siteCount: number;
};
const GroupAccordionHeader = ({ hiringSiteState, siteCount }: GroupAccordionHeaderProps): JSX.Element => {
  return (
    <Accordion.Heading className="margin-top-3" controls={hiringSiteState.code}>
      {`${hiringSiteState?.displayName} `}
      <Tag className="margin-left-2 margin-bottom-neg-2">
        {siteCount}
        <span className="usa-sr-only">{siteCount > 1 ? ' Hiring Sites' : ' Hiring Site'}</span>
      </Tag>
    </Accordion.Heading>
  );
};
export default GroupAccordionHeader;
